import React from 'react';

import {ErrorBoundary} from '@sentry/react';
import {Skeleton} from 'src/components/skeleton';

import {BoxLoading} from '@pb/kit-component-box-loading';

import {AccessDeniedErrorView, LoadingErrorView} from './loading-error-view';

import type {Error} from 'src/openapi/admin/models/Error';

type Props = {
    isLoading: boolean,
    hasLoadingError: boolean | Error | null,
    children: React.ReactNode,
    skeletonView?: React.ReactNode,
    boxLoading?: boolean,
};

const getContent = (hasLoadingError: boolean | Error | null, children: React.ReactNode) => {
    if (typeof hasLoadingError === 'object' && hasLoadingError?.status === 403) {
        return <AccessDeniedErrorView/>;
    }
    if (hasLoadingError) {
        return <LoadingErrorView/>;
    }

    return children;
};

export const SmartSection: React.FC<Props> = props => {
    const {isLoading, hasLoadingError, skeletonView, children, boxLoading} = props;

    if (boxLoading) {
        return (
            <ErrorBoundary fallback={<LoadingErrorView/>}>
                <BoxLoading loading={isLoading}>
                    {getContent(hasLoadingError, children)}
                </BoxLoading>
            </ErrorBoundary>
        );
    }

    if (skeletonView) {
        return (
            <ErrorBoundary fallback={<LoadingErrorView/>}>
                <Skeleton view={skeletonView} shown={isLoading}>
                    {getContent(hasLoadingError, children)}
                </Skeleton>
            </ErrorBoundary>
        );
    }

    return <div/>;
};
